<template>
    <div class="qksm qksm5">
        <h4>五、财政拨款支出决算情况说明</h4>
        <div class="nogap">
            <p>
                财政拨款支出决算反映的是一般公共预算、政府性基金预算和国有资本经营预算财政拨款支出的总体情况，既包括使用本年从本级财政取得的财政拨款发生的支出，也包括使用上年度财政拨款结转资金发生的支出。
            </p>
            <p>
                2021年度财政拨款支出决算{{isMoney(T5.总计)}}万元，占本年支出合计{{calcRatio(T5.总计,T1.本年支出)}}。
                与2021年度财政拨款支出年初预算<reason type="money" classname="qksm money " name="T5总计年初" v-model:value="qksm['T5总计年初']"></reason>万元相比，
                <template v-if="num(qksm['T5总计年初'])==0">
                    （年初预算数为0万元，无法计算完成比率）
                </template>
                <template v-else>
                    完成年初预算的{{calcRatio(T5.总计,qksm['T5总计年初'])}}
                </template>。
                <template v-if="num(T5.总计) && items.length>0">
                    其中：
                </template>
            </p>
            <template v-for="(item,idx) in items" :key="item.code">
                <p><b>{{items.length>1 ? "（"+intToChinese(idx+1)+"）" :""}}{{item.lei}}</b></p>
                <p v-if="item.items.length==0">
                    {{item.lei}}。年初预算为
                    <reason type="money" classname="qksm money" :name="item.code+'年初'" v-model:value="qksm[item.code+'年初']"></reason>万元，支出决算为{{isMoney(item.value)}}万元，
                    <template v-if="num(qksm[item.code+'年初'])==num(item.value)">
                        完成年初预算的100%。决算数与年初预算数相同。
                    </template>
                    <template v-else>
                        <template v-if="num(qksm[item.code+'年初'])==0">
                            （年初预算数为0万元，无法计算完成比率）
                        </template>
                        <template v-else>
                            完成年初预算的{{calcRatio(item.value,qksm[item.code+'年初'])}}
                        </template>
                        <template v-if="calcRatio(item.value,qksm[item.code+'年初']).indexOf('四舍五入后为100%')>-1">
                            决算数与年初预算数基本持平。
                        </template>
                        <template v-else>
                            。决算数与年初预算数的差异原因：
                            <reason type="textarea" classname="qksm widest" :name="'T5'+item.code+'原因'" v-model:value="qksm['T5'+item.code+'原因']"></reason>
                        </template>
                    </template>
                </p>
                <p v-else v-for="(items,idy) in item.items" :key="items.code">
                    {{item.items.length>1 ? idy+1+". " :""}}{{items.kuan}}{{items.xiang}}。年初预算为
                    <reason type="money" classname="qksm money" :name="items.code+'年初'" v-model:value="qksm[items.code+'年初']"></reason>万元，支出决算为{{isMoney(items.value)}}万元，
                    <template v-if="num(qksm[items.code+'年初'])==num(items.value)">
                        完成年初预算的100%。决算数与年初预算数相同。
                    </template>
                    <template v-else>
                        <template v-if="num(qksm[items.code+'年初'])==0">
                            （年初预算数为0万元，无法计算完成比率）
                        </template>
                        <template v-else>
                            完成年初预算的{{calcRatio(items.value,qksm[items.code+'年初'])}}
                        </template>
                        <template v-if="calcRatio(items.value,qksm[items.code+'年初']).indexOf('四舍五入后为100%')>-1">
                            决算数与年初预算数基本持平。
                        </template>
                        <template v-else>
                            。决算数与年初预算数的差异原因：
                            <reason type="textarea" classname="qksm widest" :name="'T5'+items.code+'原因'" v-model:value="qksm['T5'+items.code+'原因']"></reason>
                        </template>
                    </template>
                </p>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm5",
        data() {
            var arr = [];
            this.T5.items.map(a => {
                var arrKuan = [];
                a.children.map(b => {
                    if (b.children.length == 0) {
                        arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: "", code: b.code, value: b.value, })
                    } else {
                        b.children.map(c => {
                            arrKuan.push({ lei: a.name, kuan: b.name + "（款）", xiang: c.name + "（项）", code: c.code, value: c.value, })
                        })
                    }
                })
                arr.push({ lei: a.name + "（类）", code: a.code, value: a.value, items: arrKuan })
            })
            
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
                items: arr,
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.inspect()
        },
        methods:{
            inspect() {
                let sum = 0 ;
                this.items.forEach(e=>{
                    if(e.items.length == 0){
                        sum = sum + this.num(this.qksm[e.code + '年初'])
                    }else{
                        e.items.forEach(i=>{
                            sum = sum + this.num(this.qksm[i.code + '年初'])
                        })
                    }
                })
                let abs = this.num(Math.abs(this.num(this.qksm['T5总计年初']) - sum).toFixed(2))
                if(abs > 0.02){
                    this.addOrSet("qksm5", "请检查本页《五、财政拨款支出决算情况说明》，各项年初预算数总和应该等于2021年度财政拨款支出年初预算总数。");
                }else{
                    this.remove("qksm5")
                }
            }
        },
        props: {
            T1: {
                type: Object,
                default: "",
            },
            T5: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>